export const trapFocus = (e: KeyboardEvent, modalId: string) => {
	const isTabPressed = e.key === 'Tab' || e.keyCode === 9
	if (!isTabPressed) {
		return
	}
	const modal = document.getElementById(modalId)
	if (!modal) {
		return
	}

	const focusableChildren = Array.from(modal.querySelectorAll('button, a, select, textarea')) as HTMLButtonElement[]
	const firstFocusableElement = focusableChildren[0]

	if (!firstFocusableElement || !focusableChildren) {
		return
	}
	const lastFocusableElement = focusableChildren[focusableChildren.length - 1]

	if (!lastFocusableElement) {
		return
	}

	if (e.shiftKey) {
		if (document.activeElement === firstFocusableElement) {
			lastFocusableElement.focus()
			e.preventDefault()
		}
	} else if (document.activeElement === lastFocusableElement) {
		firstFocusableElement.focus()
		e.preventDefault()
	}
}
